import React            from 'react'
import { withRouter   } from 'react-router'
import { Link         } from 'react-router-dom'
import { Alert        } from 'react-bootstrap'

import { Registration                       } from 'alto-react-base-auth/lib/components'
import { cardNumberForm, registrationWithBV } from 'alto-react-client-auth/lib/routes'

# used when bill verification is enabled, but not needed in this case
class LoginCredentialsFormWithoutBV extends Registration.WrappedComponent
  constructor: (props, context) ->
    super(props, context)

    state = props.location.state

    if state and state.card_number and state.email
      @cardNumber = state.card_number
      @email      = state.email
    else
      # missing state, redirect back to card number form
      props.history.replace(cardNumberForm)

  info: ->
    linkLocation =
      pathname: registrationWithBV,
      state:
        email: @email
        card_number: @cardNumber
        reason: 'choose_different_email'

    bvLink = <Link to={linkLocation} id='bv-link'>registraci s ověřením dokladu</Link>

    <Alert bsStyle="info">
      Aktivační email bude zaslán na email <strong>{@email}</strong>.<br />
      Pokud se chcete registrovat <strong>s jiným emailem</strong>,
      použijte&nbsp;<strong>{bvLink}</strong>.
    </Alert>

  alert: ->
    <div>
      {super()}
      {<Alert bsStyle="danger">{@state.errors.email}</Alert> if @state.errors?.email}
    </div>

  emailInput:   ->
  isEmailValid: -> true

  register: (credentials) ->
    @context.auth.registerClient(@cardNumber, credentials)

export default withRouter(LoginCredentialsFormWithoutBV)
